module.exports = __webpack_public_path__ + "static/media/arrow-left.f2940826.svg";